export * from "./rpc.common";
import * as default_1 from "./rpc.common";
export default default_1;
//# sourceMappingURL=rpc.js.map